import { TableCell, type TableCellProps } from './TableCell'

export type TableRowProps = {
  cells: TableCellProps[]
  href?: string | null
}

export class TableRow {
  cells: TableCell[]
  href?: string | null

  constructor({ cells, href }: TableRowProps) {
    this.cells = cells.map((cell) => new TableCell(cell))
    this.href = href
  }
}
